import EntityManager from '@/pages/admin/components/EntityManager';
import { sermonFields, sermonColumns } from '@/pages/admin/entityConfigs';

export default function SermonsPage() {
  return (
    <EntityManager
      table="sermons"
      fields={sermonFields}
      columns={sermonColumns}
      orderBy="preached_on"
      searchKeys={['title', 'speaker', 'series']}
      addLabel="Add Sermon"
    />
  );
}